import WRAP from "WRAP-JS";
import {
  configHeliportDh,
  configHeliportLayer
} from "./config/ConfigHeliport";
import { COMMUNICATE_ERROR_MESSAGE_HELIPORT, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../../../constants/ErrorMessage";

export const HELIPORT_TYPE_MLIT = "Heliport_MLIT";
export const HELIPORT_TYPE_CUSTOM = "Heliport_Custom";

class Heliport {
  static NAME = "Heliport";
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [HELIPORT_TYPE_MLIT]: true,
    [HELIPORT_TYPE_CUSTOM]: true,
  };

  contentsVisibleState = {...Heliport.CONTENTS_VISIBLE_STATE_DEFAULT};

  tileIndex;
  dh;
  layer;
  ready = false;
  isDark;
  contentsDispatcher;
  errorMessageInfo;

  constructor(isDark) {
    this.isDark = isDark;
    this.layer = new WRAP.Geo.Layer(Heliport.NAME);
    this.layer.setVisible(false);
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.ready = true;
  }

  initData() {

    this.dh = new WRAP.Data(configHeliportDh);
    return new Promise((resolve) => {
      this.dh.updated('index', ref => {
        if (this.errorMessageInfo) {
          this.contentsDispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo});
          this.errorMessageInfo = null;
        }
        if (ref && Array.isArray(ref) && ref.length > 0) {
          this.tileIndex = ref[0].Prefix;
        }
        if (this.tileIndex) {
          resolve();
        }
      }, () => {
        this.errorMessageInfo = this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_HELIPORT,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
      });
    });

  }

  initLayer() {
    this.layer.configure(this.dh, configHeliportLayer);
    this.layer.set({
      index: this.tileIndex
    });
    this.applyMapColor(null, this.isDark);

    this.layer.setAttributes({
      filter: this._visibleFilter.bind(this)
    });
  }

  async drawLayer(visible) {
    if (!this.ready) {
      await this.initialize();
    }
    this.setVisible(visible);
  }

  getLayer() {
    return this.layer;
  }

  setVisible(visible, contents) {
    if (contents) {
      this.contentsVisibleState[contents] = visible;
    }

    if (!this.ready) return;

    if (contents) {
      this.layer.invalidate();
    } else {
      if (visible) {
        this.layer.show();
      } else {
        this.layer.hide();
      }
    }
  }

  changeRoutePointEditing(routePointEditing) {
    this.layer.disableInteraction(routePointEditing);
  }

  applyMapColor(mapColor, isDark) {
    this.isDark = isDark;
    const style = this.isDark ? "dark" : "default";
    this.layer.setStyle(style);
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...Heliport.CONTENTS_VISIBLE_STATE_DEFAULT};
  }

  _visibleFilter(feature) {
    const key = feature.properties.type === 'MLIT' ? HELIPORT_TYPE_MLIT : HELIPORT_TYPE_CUSTOM;
    return this.contentsVisibleState[key];
  }

  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }
}

export default Heliport;